var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueFullCalendar',{ref:"fullCalendar",staticClass:"app-calendar",attrs:{"defaultView":"dayGridMonth","header":_vm.header,"plugins":_vm.calendarPlugins,"events":_vm.calendarEvents,"editable":true,"selectable":true,"time-zone":"UTC","contentHeight":"auto"},on:{"eventClick":_vm.handleEventClick,"datesRender":_vm.handleDatesRender}})
}
var staticRenderFns = []

export { render, staticRenderFns }